import { Button, Paper } from "@material-ui/core";
import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { BootstrapTable } from "react-bootstrap-table";

import _ from "lodash";
import "./Crud.css";
import Loader from "./loader/Loader";

import { writeAoaToFile } from "../../utils/excelExport";

const defaultSort = (groupedData) => {
  const items = Object.values(groupedData).map((Values) => {
    const [{ IdGame, SportOrder, GHomeScore, GameDate, GameDateTime }] = Values;

    return {
      IdGame,
      SportOrder,
      GHomeScore,
      GameDate: new Date(GameDate),
      GameDateTime: new Date(GameDateTime),
      Values,
    };
  });

  return _.orderBy(items, [
    "GameDate",
    "SportOrder",
    "GameDateTime",
    "IdGame",
    "GHomeScore",
  ]);
};

function ReportByGame({
  controlledData,
  title,
  className = "",
  initialData = [],
  hasTotal = false,
  groupBy = "IdGame",
  getUrl,
  getParams,
  getProcess,
  getGroupTitle,
  omitGroup,
  getPostProcess = defaultSort,
  children,
  columnDef,
  toolbar,
  viewTransform,
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const cancelTokenSource = useRef(null);

  useEffect(() => {
    if (controlledData) {
      setData(controlledData);
    }
  }, [controlledData]);

  /**
   * GET
   */
  const requestData = useCallback(() => {
    const currentCancelToken = cancelTokenSource.current;
    cancelTokenSource.current = axios.CancelToken.source();

    if (currentCancelToken) {
      currentCancelToken.cancel("Canceling previous request");
    }

    setLoading(true);

    const url = process.env.REACT_APP_API2_URL + getUrl(userInfo);
    axios
      .post(
        url,
        getParams instanceof Function ? getParams(userInfo) : undefined,
        {
          cancelToken: cancelTokenSource.current.token,
        }
      )
      .then((response) => response.data)
      .then((data) => {
        const params = getParams(userInfo);
        if (params.Sport) {
          data = data.filter((item) => item.IdSport === params.Sport);
        }

        const groupedData = !omitGroup
          ? _.groupBy(data, groupBy)
          : data.reduce((acc, curr, index) => {
              acc[`item-${index}`] = [curr];
              return acc;
            }, {});

        _.forEach(groupedData, (values, key) => {
          groupedData[key] = values.map((item, index) => ({
            ...item,
            Id: item.IdGame + index,
          }));
        });

        const sortedItems = getPostProcess(groupedData);

        setData(sortedItems);
        setLoading(false);
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error(err);
        }
      });

    return () => {
      currentCancelToken.cancel("Component unmounted");
    };
  }, [userInfo, getParams, groupBy, getPostProcess, getUrl, omitGroup]);

  const onSearch = useCallback(() => {
    requestData();
  }, [requestData]);

  // Sort/filtro aplicados en tiempo de render sobre los datos ya cargados,
  // para no re-consultar la API al reordenar o buscar.
  const viewData = useMemo(
    () => (viewTransform instanceof Function ? viewTransform(data) : data),
    [data, viewTransform]
  );

  /**
   * TABLE OPTIONS
   */
  const options = {
    page: 1, // which page you want to show as default
    sizePerPage: 20, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 5, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "top", // default is bottom, top and both is all available
    withFirstAndLast: true, // Hide the going to First and Last page button
  };

  const render = ({ Values, IsNested }) => {
    if (IsNested) {
      return Values.map((item) => render(item));
    }

    const sport = Values?.[0].IdSport?.toLowerCase().trim();

    return (
      <BootstrapTable
        headerContainerClass={columnDef instanceof Function ? "" : "hidden"}
        className="text-xxs  compact-table table-auto-width"
        data={getProcess(sport, Values)}
        options={options}
        version="4"
      >
        {columnDef ? columnDef(sport) : children}
      </BootstrapTable>
    );
  };

  const getTotal = () => {
    const items = _.map(data, (values) => values?.[0]).flat(Infinity);
    return [
      {
        Game: "",
        Date: "Total",
        Side: items.reduce((acc, item) => acc + item.Side, 0),
        Total: items.reduce((acc, item) => acc + item.Total, 0),
        MoneyLine: items.reduce((acc, item) => acc + item.MoneyLine, 0),
        SumTotal: items.reduce(
          (acc, item) => acc + item.Side + item.Total + item.MoneyLine,
          0
        ),
      },
    ];
  };

//   function exportGameScoreReport(data) {
//     const worksheetData = [];
//     const params = getParams(userInfo);
//     // Encabezado principal
//     worksheetData.push(["Game Score Report"]); // Título    

//     worksheetData.push([`From: ${params.StartDate}` + " - " + `To: ${params.EndDate}`]);
//     worksheetData.push([]); // Espacio en blanco
    
//     // Encabezados de la tabla
//     worksheetData.push([
//       "Sport",
//       "Game Date",
//       "Visitor/Home",
//       "Game",
//       "1H",
//       "2H",
//       "1Q",
//       "2Q",
//       "3Q",
//       "Graded",
//     ]);
  
//     // Agregar datos de juegos con espacios
//     data.forEach((gam) => {
//       const game = gam.Values[0];
//       const dGraded = game.GradedDate.split(".")[0];
//       console.log(game)
//       const [date, time] = game.GameDateTime.split("T");
//       const [dateGraded, timeGraded] = dGraded.split("T");
//       // Fila para el equipo visitante
//       worksheetData.push([
//         game.IdSport,
//         date,
//         game.VisitorName,
//         game.GVisitorScore !== null ? String(game.GVisitorScore) : '',
//         game.VisitorScore1H !== null ? String(game.VisitorScore1H) : '',
//         game.VisitorScore2H !== null ? String(game.VisitorScore2H) : '',
//         game.VisitorScore1Q !== null ? String(game.VisitorScore1Q) : '',
//         game.VisitorScore2Q !== null ? String(game.VisitorScore2Q) : '',
//         game.VisitorScore3Q !== null ? String(game.VisitorScore3Q) : '',
//         dateGraded,
//       ]);
  
//       // Fila para el equipo local
//       worksheetData.push([
//         "",
//         time,
//         game.HomeName,
//         game.GHomeScore !== null ? String(game.GHomeScore) : '',
//         game.HomeScore1H !== null ? String(game.HomeScore1H) : '',
//         game.HomeScore2H !== null ? String(game.HomeScore2H) : '',
//         game.HomeScore1Q !== null ? String(game.HomeScore1Q) : '',
//         game.HomeScore2Q !== null ? String(game.HomeScore2Q) : '',
//         game.HomeScore3Q !== null ? String(game.HomeScore3Q) : '',
//         timeGraded,
//       ]);
  
//       // Espacio entre juegos
//       worksheetData.push([]);
//     });
  
//     // Crear hoja de trabajo
//     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
//     // Fusionar celdas para centrar el título (opcional, pero sin estilos)
//     worksheet["!merges"] = [
//       { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }, // Fusiona A1 a I1 para el título
//     ];
  
//     // Crear el libro y guardar
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Game Report");
//     XLSX.writeFile(workbook, "game_score_report.xlsx");
// }

  async function exportGameScoreReport(data) {
    const worksheetData = [];
    const params = getParams(userInfo);
    
    // Encabezado principal
    worksheetData.push(["Game Score Report"]); // Título    
    worksheetData.push([`From: ${params.StartDate}` + " - " + `To: ${params.EndDate}`]);
    worksheetData.push([]); 
    
    // Encabezados de la tabla
    worksheetData.push([
        "Sport",
        "Game Date",
        "Visitor/Home",
        "Game",
        "1H",
        "2H",
        "1Q",
        "2Q",
        "3Q",
        "Graded",
    ]);

    data.forEach((gam) => {
        const values = gam.Values;
        if (values.length > 0) {
            const firstGame = values[0];
            const dGraded = firstGame.GradedDate.split(".")[0];
            const [date, time] = firstGame.GameDateTime.split("T");
            const [dateGraded, timeGraded] = dGraded.split("T");

            // Fila para el equipo visitante
            worksheetData.push([
                firstGame.IdSport,
                date,
                firstGame.VisitorName,
                firstGame.GVisitorScore !== null ? String(firstGame.GVisitorScore) : '',
                firstGame.VisitorScore1H !== null ? String(firstGame.VisitorScore1H) : '',
                firstGame.VisitorScore2H !== null ? String(firstGame.VisitorScore2H) : '',
                firstGame.VisitorScore1Q !== null ? String(firstGame.VisitorScore1Q) : '',
                firstGame.VisitorScore2Q !== null ? String(firstGame.VisitorScore2Q) : '',
                firstGame.VisitorScore3Q !== null ? String(firstGame.VisitorScore3Q) : '',
                dateGraded,
            ]);

            // Fila para el equipo local
            worksheetData.push([
                "",
                time,
                firstGame.HomeName + (firstGame.Result == 1 ? " [Winner]" : ""),
                values.length > 1 ? "" : (firstGame.GHomeScore !== null ? String(firstGame.GHomeScore) : 'Cancelled'),
                firstGame.HomeScore1H !== null ? String(firstGame.HomeScore1H) : '',
                firstGame.HomeScore2H !== null ? String(firstGame.HomeScore2H) : '',
                firstGame.HomeScore1Q !== null ? String(firstGame.HomeScore1Q) : '',
                firstGame.HomeScore2Q !== null ? String(firstGame.HomeScore2Q) : '',
                firstGame.HomeScore3Q !== null ? String(firstGame.HomeScore3Q) : '',
                timeGraded,
            ]);

            for (let i = 1; i < values.length; i++) {
                const game = values[i];
                worksheetData.push([
                    "",
                    "",
                    game.HomeName + (game.Result == 1 ? " [Winner]" : ""),
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                ]);
            }

            worksheetData.push([]);
        }
    });

    await writeAoaToFile(worksheetData, "Game Report", "game_score_report.xlsx", {
      merges: [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }],
    });
  }

  if (loading) return <Loader />;
  return (
    <div id="main-div" className={`${className} !h-max flex flex-col gap-4`}>
      <div className="flex flex-row gap-4 mb-4">
        <Button
          type="button"
          onClick={onSearch}
          color="primary"
          variant="contained"
        >
          Search
        </Button>
        {
          getUrl(userInfo).includes("Report_Game_Score_2") && viewData.length > 0 &&
        <Button
            type="button"
            color="primary"
            variant="contained"
            onClick={()=>exportGameScoreReport(viewData)}
          >
            Export XLSX
          </Button>
        }
      </div>

      <div className="flex items-center justify-between gap-4 flex-wrap">
        <h2>{title}</h2>
        {!_.isEmpty(data) ? toolbar : null}
      </div>
      {!_.isEmpty(data) ? (
        <Paper className="flex flex-col gap-4">
          {!columnDef ? (
            <BootstrapTable
              className="sticky text-xxs compact-table top-4"
              data={[]}
              version="4"
              hover
              bodyContainerClass="hidden"
            >
              {children}
            </BootstrapTable>
          ) : null}

          {_.map(viewData, (item, key) => (
            <>
              {getGroupTitle instanceof Function ? getGroupTitle(item) : null}
              <React.Fragment key={key}>{render(item)}</React.Fragment>
            </>
          ))}
          <hr className="border-gray-200" />
          {hasTotal ? (
            <BootstrapTable
              className="font-bold text-xxs compact-table"
              data={getTotal()}
              version="4"
              hover
              headerContainerClass={
                columnDef instanceof Function ? "" : "hidden"
              }
            >
              {children}
            </BootstrapTable>
          ) : null}
        </Paper>
      ) : null}
    </div>
  );
}

export default ReportByGame;
